<!-- <style>
	.pagination ::ng-deep .ngx-pagination .current {
		background: #e65100;
	}
</style> -->
<h1 class="page-header"><i class="fa fa-list-alt" aria-hidden="true"></i> DIALOGS</h1>
<div class="container-fluid">

	<div class="tab-content">
	<!-- ADD Button - Used to add new Dialog -->
	<div class="page-button">
		<button class="btn btn-ef" type="button" disabled title="Not Available"><i class="fa fa-plus" aria-hidden="true"></i>
			ADD NEW</button>
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><i
					class="fa fa-wrench"></i> ACTIONS <span class="caret"></span></button>
			<ul class="dropdown-menu">
				<li (click)="deleteSelectedDialogsClicked()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-close"></em>
						DELETE</a></li>
			</ul>
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li (click)="setFilterDialog(null, null)"><a>REMOVE FILTER</a></li>
				<li (click)="setFilterDialog('Name', 'name')"><a>Name</a></li>
			</ul>
		</div>
		<div *ngIf="filterColumnDialog != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameDialog }}
		</div>
		<div *ngIf="filterColumnDialog != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringDialog" (ngModelChange)="filterStringChangedDialog()">
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em class="fa fa-bars"></em> RESULTS
				PER PAGE <span class="caret"></span></button>
			<ul class="dropdown-menu">
				<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForDialogs(value)"
					[class.active]="value === selectedPageSizeValueForDialogs">
					<a>{{ value }}</a>
				</li>
			</ul>
		</div>

	</div>

	<!-- Dialogs -->
	<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
		role="grid">
		<thead>
			<tr role="row" class="tablesorter-headerRow">
				<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0"
					scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label=": No sort applied, activate to apply an ascending sort"
					style="user-select: none; width: 20px">
					<div class="tablesorter-header-inner">
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
								[checked]="isAllSelected()" (change)="selectAll($event)"><label for="checkbox"></label>
						</div>
					</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
					aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">NAME</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
					aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Level: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">LEVEL</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Type Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">TYPE NAME</div>
				</th>
				<!-- <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Rules: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">RULES</div>
				</th> -->
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="DELETE available Dialogs">
					<div class="tablesorter-header-inner">DELETE</div>
				</th>
			</tr>
		</thead>
		<tbody aria-live="polite" aria-relevant="all">
			<ng-container
				*ngFor="let dialogUI of selectedDialogs | paginate: {id: 'dialog_pagination', itemsPerPage: selectedPageSizeValueForDialogs, currentPage: currentPageForDialogs, totalItems: totalNumberOfDialogs }">
				<tr>
					<td>
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
								[(ngModel)]="dialogUI.selected"><label for="checkbox"></label></div>
					</td>
					<td>{{dialogUI.dialog.name}}</td>
					<td>{{dialogUI.dialog.level}}</td>
					<td>{{dialogUI.dialog.type}}</td>
					<!-- <td>
						<ng-container *ngIf="dialogUI.dialog != null && dialogUI.rules != null && dialogUI.rules.length > 0">
								<button class="groupButton" *ngFor="let rule of dialogUI.rules">{{ rule.name }}</button>
						</ng-container>
					</td> -->
					<td><button class="btn btn-ef" (click)="deleteDialog(dialogUI.dialog)">DELETE</button></td>
				</tr>
			</ng-container>
		</tbody>
	</table>

	<pagination-controls class="pagination" id="dialog_pagination" (pageChange)="pageChanged($event)"
		[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
	</pagination-controls>

	</div>
</div>
